import { Schema } from 'rsuite';
import { phoneNumberRegex } from 'utils/regex';
import formValidation from 'constants/validation';

const { StringType } = Schema.Types;

export const authSignInFormModel = Schema.Model({
  email: StringType()
    .isRequired('Please enter a valid email.')
    .isEmail('Please enter a valid email.'),
  password: StringType().isRequired('Please enter your password.'),
});

export const authForgotPasswordFormModel = Schema.Model({
  email: StringType()
    .isRequired('Please enter a valid email.')
    .isEmail('Please enter a valid email.'),
});

/** Set / change / reset password flows (password + confirmation) */
export const authPasswordWithConfirmFormModel = Schema.Model({
  password: StringType()
    .isRequired('Please enter a valid password.')
    .minLength(8, 'Use at least 8 characters.'),
  passwordConfirm: StringType()
    .isRequired('Please re-enter your password.')
    .addRule((value, data) => {
      if (value !== data.password) {
        return false;
      }
      return true;
    }, 'Passwords do not match.'),
});

export const authSignUpFormModel = Schema.Model({
  firstName: StringType()
    .isRequired('Enter your first name.')
    .maxLength(50, 'Enter your first name.'),
  lastName: StringType()
    .isRequired('Enter your last name.')
    .maxLength(50, 'Enter your last name.'),
  school: StringType().isRequired(formValidation.errorMessages.school),
  schoolOther: StringType().addRule((value, data) => {
    if (String(data?.school ?? '').toLowerCase() !== 'other') return true;
    return String(value ?? '').trim().length > 0;
  }, formValidation.errorMessages.school),
  grade: StringType().isRequired(formValidation.errorMessages.gradeLevel),
  ethnicity: StringType(),
  ethnicityOther: StringType().addRule((value, data) => {
    if (String(data?.ethnicity ?? '').toLowerCase() !== 'other') return true;
    return String(value ?? '').trim().length > 0;
  }, 'Enter your ethnicity.'),
  email: StringType()
    .isRequired('Enter a valid email address.')
    .isEmail('Enter a valid email address.'),
  phoneNumber: StringType()
    .isRequired('Enter a 10-digit phone number.')
    .addRule(
      value => phoneNumberRegex.test(String(value ?? '')),
      'Enter a 10-digit phone number.',
    ),
  password: StringType()
    .isRequired('Use at least 8 characters.')
    .minLength(8, 'Use at least 8 characters.'),
  verifyPassword: StringType()
    .isRequired("Passwords don't match.")
    .addRule((value, data) => value === data.password, "Passwords don't match."),
});
